import { patientApi } from '@/api/PatientApi'
import { useQuery } from '@tanstack/react-query'

export const PAYMENT_PLANS_QUERY_KEY = ['payment-plans']

const usePaymentPlans = () => {
	const { data, isLoading, isError } = useQuery({
		queryKey: PAYMENT_PLANS_QUERY_KEY,
		queryFn: () => patientApi.getPaymentPlans(),
		staleTime: 30000,
	})

	return {
		plans: data,
		isLoading,
		isError,
	}
}

export { usePaymentPlans }
